import GoogleAnalytics from './destinations/GoogleAnalytics';
import Facebook from './destinations/Facebook';
import SOURCE from './constants/Source';
import EventPropertyKeys from './constants/EventPropertyKeys';

class CCEvents {
  activeScreen = '';

  initializeDestinations() {}

  cleanUp() {}

  setActiveScreen(screenName) {
    this.activeScreen = screenName;
  }

  logEvent(name, properties = {}) {
    // Add source to properties (sent source property will overwrite default here)
    const stampedProperties = {
      [EventPropertyKeys.SOURCE]: SOURCE,
      ...properties,
    };

    if (this.activeScreen) {
      stampedProperties.screen = this.activeScreen;
    }

    GoogleAnalytics.logEvent(name, stampedProperties);
    Facebook.logEvent(name, stampedProperties);
  }
}

export default new CCEvents();
